import { FC } from 'react';

import { Modal, ModalActionProps, ModalTypes } from '@dbt-labs/sourdough';

import { useModalProvider } from '@/context/ModalProvider';

interface CustomModalProps {
  isModalVisible: boolean;
  title: string;
  children: React.ReactNode;
  modalType: ModalTypes;
  actions?: ModalActionProps[];
}

export const CustomModal: FC<CustomModalProps> = ({
  isModalVisible,
  title,
  children,
  modalType,
  actions,
}) => {
  const { closeModal } = useModalProvider();
  return (
    <Modal
      title={title}
      isOpen={isModalVisible}
      onClose={() => closeModal()}
      modalType={modalType}
      actions={actions}
    >
      {children}
    </Modal>
  );
};
